import {
  getCountriesAction,
  uploadVenueImagesAction,
  cleanVenueModalStoreAction,
  getMediaAction,
  getImageFormats,
} from './actions';
import { defaultMediaParams, listReducer, namedListParams } from '../../utils/crudUtils';

export const key = 'VenueModal';

export const initialState = {
  uploadedVenueImages: defaultMediaParams,
  countries: namedListParams('countries'),
  media: namedListParams('media'),
  imageFormats: namedListParams('imageFormats'),
};

const venueModalReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case uploadVenueImagesAction.TRIGGER:
      return { ...state, uploadedVenueImage: { ...defaultMediaParams, uploading: true } };
    case uploadVenueImagesAction.SUCCESS:
      return { ...state, uploadedVenueImage: { ...defaultMediaParams, data: payload, uploaded: true } };
    case uploadVenueImagesAction.FAILURE:
      return { ...state, uploadedVenueImage: { ...defaultMediaParams, error: payload } };

    case getCountriesAction.TRIGGER:
    case getCountriesAction.SUCCESS:
    case getCountriesAction.FAILURE:
      return listReducer(state, type, payload, initialState.countries.listName);

    case getMediaAction.TRIGGER:
    case getMediaAction.SUCCESS:
    case getMediaAction.FAILURE:
      return listReducer(state, type, payload, initialState.media.listName);

    case cleanVenueModalStoreAction.TRIGGER:
      return { ...initialState, countries: state.countries };

    case getImageFormats.TRIGGER:
    case getImageFormats.SUCCESS:
    case getImageFormats.FAILURE:
      return listReducer(state, type, payload, initialState.imageFormats.listName);

    default:
      return state;
  }
};

export default venueModalReducer;
